(function () {
  if (window.__furleeCardHoverVideoInit) return;
  window.__furleeCardHoverVideoInit = true;

  function findVideo(card) {
    return card.querySelector('.card__hover-video');
  }

  function startVideo(card, video) {
    if (!video) return;
    if (!video.src && video.dataset.hoverVideoSrc) {
      video.src = video.dataset.hoverVideoSrc;
    }
    card.classList.add('card-wrapper--previewing');
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function stopVideo(card, video) {
    if (card) card.classList.remove('card-wrapper--previewing');
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  }

  // Desktop: hover with a mouse.
  // 2026-08-29 follow-up (real bug fix): mobile browsers fire a *synthetic*
  // mouseover on whatever element was tapped, as part of their standard
  // touch-to-mouse-event compatibility shim — and on some browsers
  // (confirmed Android Chrome) that synthetic event fires ~300ms AFTER the
  // real click already ran, not before it. Tapping "360 Video" already
  // stops this in-card preview and opens the popup (see the click handler
  // below) — but the synthetic mouseover firing afterward would restart
  // this preview with nothing to stop it again, so it kept playing behind
  // the popup at the same time as the popup's own copy of the video.
  // Guarding it out here the same way the touchstart handler already
  // guards the button below fixes it.
  document.addEventListener('mouseover', function (event) {
    if (event.target.closest && event.target.closest('.card__video-button')) return;
    var card = event.target.closest ? event.target.closest('.card-wrapper') : null;
    if (!card) return;
    startVideo(card, findVideo(card));
  });

  document.addEventListener('mouseout', function (event) {
    var card = event.target.closest ? event.target.closest('.card-wrapper') : null;
    if (!card) return;
    if (card.contains(event.relatedTarget)) return;
    stopVideo(card, findVideo(card));
  });

  // Mobile: press and hold. A quick tap still opens the product as normal;
  // only a genuine hold (past LONG_PRESS_MS) starts the preview, and in
  // that case releasing swallows the tap so it doesn't also navigate.
  var LONG_PRESS_MS = 180;
  var MOVE_CANCEL_PX = 10;
  var pressTimer = null;
  var pressCard = null;
  var pressVideo = null;
  var previewActive = false;
  var startX = 0;
  var startY = 0;

  function clearPress() {
    clearTimeout(pressTimer);
    pressTimer = null;
    if (previewActive) {
      stopVideo(pressCard, pressVideo);
    }
    previewActive = false;
    pressCard = null;
    pressVideo = null;
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      // Tapping the "360 Video" button shouldn't also arm the long-press
      // inline preview underneath it — without this, a tap that happens to
      // land past LONG_PRESS_MS (180ms) starts the small in-card preview
      // video playing at the same time the popup opens.
      if (event.target.closest && event.target.closest('.card__video-button')) return;
      var card = event.target.closest ? event.target.closest('.card-wrapper') : null;
      if (!card) return;
      var video = findVideo(card);
      if (!video) return;
      var touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      pressCard = card;
      pressVideo = video;
      previewActive = false;
      pressTimer = setTimeout(function () {
        previewActive = true;
        startVideo(pressCard, pressVideo);
      }, LONG_PRESS_MS);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!pressCard) return;
      var touch = event.touches[0];
      var dx = Math.abs(touch.clientX - startX);
      var dy = Math.abs(touch.clientY - startY);
      if (dx > MOVE_CANCEL_PX || dy > MOVE_CANCEL_PX) {
        clearPress();
      }
    },
    { passive: true }
  );

  document.addEventListener('touchend', function (event) {
    if (!pressCard) return;
    if (previewActive) {
      // A hold was in progress: stop that tap from also navigating to the
      // product page.
      event.preventDefault();
    }
    clearPress();
  });

  document.addEventListener('touchcancel', function () {
    clearPress();
  });

  // "360 Video" button popup, mobile only. Reuses the same video file the
  // hover-preview <video> already points at (set from hover_video_file in
  // card-product.liquid), just played fullscreen-ish in a lazily-built,
  // reusable popup instead of the small inline preview.
  var popup = null;
  var popupVideo = null;

  function ensurePopup() {
    if (popup) return popup;
    popup = document.createElement('div');
    popup.className = 'card-video-popup';
    popup.innerHTML =
      '<div class="card-video-popup__frame">' +
      '<button type="button" class="card-video-popup__close" aria-label="Close video">&times;</button>' +
      '<video class="card-video-popup__video" playsinline controls loop></video>' +
      '</div>';
    document.body.appendChild(popup);
    popupVideo = popup.querySelector('.card-video-popup__video');
    popup.querySelector('.card-video-popup__close').addEventListener('click', closePopup);
    popup.addEventListener('click', function (event) {
      if (event.target === popup) closePopup();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('active')) closePopup();
    });
    return popup;
  }

  function openPopup(src) {
    ensurePopup();
    popupVideo.src = src;
    popup.classList.add('active');
    document.body.classList.add('card-video-popup-open');
    var playPromise = popupVideo.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('active');
    document.body.classList.remove('card-video-popup-open');
    popupVideo.pause();
    popupVideo.removeAttribute('src');
    popupVideo.load();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.card__video-button') : null;
    if (!button) return;
    event.preventDefault();
    // Also stop the small in-card preview if it's already playing — on
    // desktop, hovering onto the card (to reach the button) already started
    // it via mouseover before the click even fires, so the popup would
    // otherwise open on top of a second copy of the same video playing in
    // the photo behind it.
    var card = button.closest('.card-wrapper');
    if (card) stopVideo(card, findVideo(card));
    var src = button.dataset.videoSrc;
    if (src) openPopup(src);
  });
})();
